module.exports = __webpack_public_path__ + "img/about-icons-regression-web.b31a921a.svg";